(function () {
  var widgetSelector = '#klaviyo-product-reviews-wrapper';
  var buttonSelector = '.kl_reviews__button';
  var widgetObserver;
  var loaderObserver;

  function syncButtonName(widget) {
    var buttons = widget.querySelectorAll(buttonSelector);

    buttons.forEach(function (button) {
      var visibleLabel = button.textContent.replace(/\s+/g, ' ').trim();
      if (visibleLabel !== 'Bewertung schreiben') return;

      var currentLabel = button.getAttribute('aria-label') || '';
      var suffix = currentLabel.match(/\s*(\([^)]*\))\s*$/);
      var accessibleLabel = visibleLabel + (suffix ? ' ' + suffix[1] : '');

      if (currentLabel !== accessibleLabel) {
        button.setAttribute('aria-label', accessibleLabel);
      }
    });
  }

  function watchWidget() {
    var widget = document.querySelector(widgetSelector);
    if (!widget) return false;

    syncButtonName(widget);

    if (!widgetObserver) {
      widgetObserver = new MutationObserver(function () {
        syncButtonName(widget);
      });
      widgetObserver.observe(widget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label']
      });
    }

    if (loaderObserver) {
      loaderObserver.disconnect();
      loaderObserver = null;
    }

    return true;
  }

  function init() {
    if (watchWidget()) return;

    var root = document.getElementById('MainContent') || document.body;
    loaderObserver = new MutationObserver(watchWidget);
    loaderObserver.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
